// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22cHI","right":"Footer_right__3DkAE","buttons":"Footer_buttons__2oA4g"};